var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"station"},[_c('div',{staticClass:"station_top",class:{end:_vm.station.status==1}},[_vm._v(_vm._s(_vm.station.status==0?'':'✔'))]),_vm._v(" "),_c('div',{staticClass:"station_text"},[_vm._v(_vm._s(_vm.station.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c8566e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/garbage/station.vue
// module id = null
// module chunks = 